export const notificationsUrls = 'notifications/';
export const notificationUrl = (notificationId: string) => `notifications/${notificationId}/`;
export const historicNotificationUrl = (assetId: string) => `notifications/asset/${assetId}/`;
export const batchNotificationsUrl = 'notifications/batch/';
export const notificationTypesUrl = 'notification/types/';
export const allNotificationTypesUrl = 'notifications/list/';
